import { FC } from 'react';
import { Card, formattedCurrency, SupportedCurrencies, Tooltip, withStyles } from 'vopay';
import styles from './TransactionLimitCard.module.scss';
import { useTranslation } from 'react-i18next';

const cn = withStyles(styles);

type TransactionLimitCardProps = {
  currencies: (SupportedCurrencies | '')[];
  limit: string;
  country: string;
};

const TransactionLimitCard: FC<TransactionLimitCardProps> = ({ currencies, limit, country }) => {
  const { t } = useTranslation('translations', { keyPrefix: 'ClientAccount.TransactionLimitCard' });
  const defaultCurrency = country === 'US' ? 'USD' : 'CAD';

  return (
    <Card
      style={{
        padding: '24px 44px 32px',
      }}
    >
      <div className={cn('transactionLimitTitle')}>{t('transactionLimit', { defaultValue: 'Transaction Limit' })}</div>

      <div className={cn('transactionLimit')}>
        {currencies.map((currency) => (
          <div key={currency || defaultCurrency} className={cn('currency')}>
            <span>{currency || defaultCurrency}</span>
            <span>{formattedCurrency(limit || '0')}</span>
            <Tooltip
              icon="info"
              position="topLeft"
              information={t('tooltip', {
                defaultValue: 'Increase your transaction limit to process transactions at higher amounts.',
              })}
            />
          </div>
        ))}
      </div>
    </Card>
  );
};

export default TransactionLimitCard;
